import React, { useEffect, useState, useMemo } from 'react';
import { motion } from 'framer-motion';
import API from '../../Common/API';
import InlineTextField from '../../Components/InLineTextField';
import DatatableLoader from '../../Components/Loaders/DataTableLoader';
import { datatableTheme } from '../../Common/dataTableTheme';
import DataTable, { createTheme } from 'react-data-table-component';
import { BsImageAlt } from 'react-icons/bs';
import { useHistory } from 'react-router-dom';
import { FaPen, FaPlus, FaTrash } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { setAlert } from '../../Store/Theme/actions';
import Dialog from '../../Components/Dialog';
import Button from '../../Components/Button';
import productTemplate from '../../Assets/templates/productDataTemplate.xlsx';

createTheme('defaultLight', datatableTheme.default);
createTheme('defaultDark', datatableTheme.dark);

const Products = () => {
    const userDetails = useSelector((state) => state.auth.userDetails);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('');
    const [productList, setProductList] = useState([]);
    const [count, setCount] = useState(0);
    const history = useHistory();
    const [openDelete, setOpenDelete] = useState(false);
    const [deleteValue, setDeleteValue] = useState();
    const dispatch = useDispatch();
    const [excelFile, setExcelFile] = useState();

    useEffect(() => {
        setLoading(true);
        API.get('/products/getAllProducts')
            .then((productRes) => {
                setProductList(productRes.data.data);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [count]);

    const columns = useMemo(
        () => [
            {
                name: 'S.No',
                selector: (row, i) => i + 1,
                initialActive: true,
                sortable: true,
                width: '100px',
            },
            {
                name: <BsImageAlt />,
                selector: (row) => {
                    return <img src={row.images[0]?.imageUrl} height={20} width={20} alt="img" />;
                },
                initialActive: true,
                width: '100px',
            },
            {
                name: 'Product Name',
                selector: (row) => row.productName,
                initialActive: true,
                sortable: true,
            },
            { name: 'Brand Name', selector: (row) => row.brandName, sortable: true },
            { name: 'Model Name', selector: (row) => row.modelName, sortable: true },
            { name: 'Price', selector: (row) => row.price, sortable: true },
            {
                name: 'Quantity',
                selector: (row) => row.stocks[0]?.quantity,
                sortable: true,
            },
            {
                name: 'Stock Mode',
                selector: (row) => row.stocks[0]?.stockMode.toUpperCase(),
                initialActive: true,
                sortable: true,
            },
            {
                name: 'Action',
                selector: (row) => (
                    <motion.div className="px-1 py-1 w-full flex flex-row justify-between cursor-pointer">
                        {/* <FaEye className="cursor-pointer" onClick={() => viewProduct(row)} />&nbsp;&nbsp;&nbsp;&nbsp; */}
                        <FaPen
                            className="cursor-pointer"
                            onClick={() =>
                                history.push(
                                    `/store/${
                                        userDetails.subject.sellerId._id ||
                                        userDetails.subject.sellerId
                                    }/editProduct/${row._id}`
                                )
                            }
                        />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <FaTrash
                            className="cursor-pointer text-[red]"
                            onClick={() => openDeleOption(row)}
                        />
                    </motion.div>
                ),
            },
        ],
        []
    );

    const filteredcasedetails = useMemo(() => {
        const filterSplit = filter.toLowerCase().split(' ');
        return productList.filter((c) =>
            filterSplit.every((i) =>
                Object.keys(c).some((j) => c[j]?.toString().toLowerCase().includes(i))
            )
        );
    }, [productList, filter]);

    const downloadTemplateExcel = () => {
        const link = document.createElement('a');
        link.href = productTemplate;
        link.download = 'product_template.xlsx'; // optional custom filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleFileChange = (e) => {
        setLoading(true);
        // setExcelFile(e.target.files[0]);
        setTimeout(() => {
            handleUpload(e.target.files[0]);
        }, 5000);
    };

    const handleUpload = async (excelFile) => {
        if (!excelFile) {
            //   setMessage("Please select a file.");
            dispatch(
                setAlert({
                    title: 'Error',
                    subtitle: 'Please select a file',
                    type: 'error',
                    active: true,
                })
            );
            setLoading(false);
            return;
        }

        const formData = new FormData();
        formData.append('file', excelFile);
        formData.append(
            'addedBy',
            userDetails.subject.sellerId._id
                ? userDetails.subject.sellerId._id
                : userDetails.subject.sellerId
        ); // or dynamically set user ID/name

        try {
            await API.post('/products/productBulkUpload', formData)
                .then((apiRes) => {
                    if (apiRes.status === 200) {
                        dispatch(
                            setAlert({
                                title: 'Success',
                                subtitle: 'Products uploaded successfully',
                                active: true,
                                type: 'success',
                            })
                        );
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    dispatch(
                        setAlert({
                            title: 'Error',
                            subtitle: 'Products upload failed',
                            active: true,
                            type: 'error',
                        })
                    );
                    setLoading(false);
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (err) {
            console.error('Upload error:', err);
        }
    };

    const downloadAvailableCategories = async () => {
        try {
            const response = await API.get('/category/xlsxCategoriesDownload', {
                responseType: 'blob',
            });
            if (response.status === 200) {
                const blob = new Blob([response.data], { type: response.headers['content-type'] });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Categories.xlsx`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            }
        } catch (err) {
            dispatch(
                setAlert({
                    title: 'Error',
                    subtitle: 'Something went wrong',
                    active: true,
                    type: 'error',
                })
            );
        }
    };

    const SubHeader = useMemo(
        () => (
            <div className="flex flex-row items-center">
                <motion.div
                    className="cursor-pointer px-2 py-2 bg-primeColor mx-2 rounded-full text-black"
                    onClick={() => downloadAvailableCategories()}
                >
                    Download categories
                </motion.div>
                <motion.div
                    onClick={() => downloadTemplateExcel()}
                    className={
                        'w-fit rounded-full bg-primeColor text-white px-2 py-2 mx-2 cursor-pointer'
                    }
                >
                    Download Template
                </motion.div>
                <motion.div
                    onClick={() => document.getElementById('bulkUploadId').click()}
                    className={
                        'w-fit rounded-full bg-primeColor text-white px-2 py-2 mx-2 cursor-pointer'
                    }
                >
                    Bulk upload
                </motion.div>
                <input
                    type="file"
                    accept=".xlsx, .xls"
                    onChange={handleFileChange}
                    className="hidden"
                    id="bulkUploadId"
                />
                <InlineTextField label={'Search'} value={filter} setValue={setFilter} />
                <motion.div
                    className="h-9 mx-2 w-9 rounded-full bg-white flex flex-col items-center cursor-pointer justify-center"
                    onClick={() =>
                        history.push(
                            `/store/${
                                userDetails.subject.sellerId._id
                                    ? userDetails.subject.sellerId._id
                                    : userDetails.subject.sellerId
                            }/addProduct`
                        )
                    }
                >
                    <FaPlus />
                </motion.div>
            </div>
        ),
        [filter]
    ); // eslint-disable-line

    const openDeleOption = (value) => {
        setOpenDelete(true);
        setDeleteValue(value);
    };

    const confirmDelete = () => {
        API.post('/products/confirmDelete', { productId: deleteValue._id })
            .then((deleteRes) => {
                if (deleteRes.status === 200) {
                    dispatch(
                        setAlert({
                            title: 'Delete',
                            subtitle: 'Product Removed Successfully',
                            active: true,
                            type: 'success',
                        })
                    );
                    setOpenDelete(false);
                    setCount(count + 1);
                }
            })
            .catch((err) => {
                dispatch(
                    setAlert({
                        title: 'Error',
                        subtitle: 'Something went wrong',
                        active: true,
                        type: 'error',
                    })
                );
            });
    };

    return (
        <motion.div>
            {loading ? (
                <DatatableLoader />
            ) : (
                <motion.div className="h-full w-full bg-opacity-10 drop-shadow-lg">
                    <DataTable
                        title="Product List"
                        theme="defaultLight"
                        columns={columns}
                        data={filteredcasedetails}
                        pagination
                        highlightOnHover
                        selectableRowsHighlight
                        persistTableHead
                        subHeader
                        subHeaderComponent={SubHeader}
                        noDataComponent={'There are no records to display'}
                    />
                </motion.div>
            )}
            <Dialog
                title={'Delete Product'}
                injectClass="py-2 w-[430px]"
                showDialog={openDelete}
                onClose={() => setOpenDelete(false)}
            >
                <motion.div className="flex w-full flex-col">
                    <p>Are you sure you want to delete this product ?</p>
                    <motion.div className="flex w-full mt-5 flex-row justify-between">
                        <Button
                            type={'danger'}
                            injectClass={'w-fit cursor-pointer'}
                            onClick={() => {
                                setDeleteValue();
                                setOpenDelete(false);
                            }}
                        >
                            No
                        </Button>
                        <Button
                            type="success"
                            injectClass={'w-fit bg-[green] text-white cursor-pointer'}
                            onClick={() => confirmDelete()}
                        >
                            Yes
                        </Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </motion.div>
    );
};

export default Products;
